import {Button, Form} from "react-bootstrap";
import logo from "../../../images/logo/Icon_company.png";
import personal_data_doc from "../../../docs/processing of personal data.pdf"
import LoadingStuck from "../../reuse/LoadingStuck";
import { useEffect, useState } from "react";
import RestorePasswordModal from "./RestorePasswordModal";
import Api, { BaseUrl, errorMessageText } from "../../../api/Api";
import { useNavigate } from "react-router";

const LoginForm = () =>{
    const [loading, setLoading]=useState(false);
    const [error, setError]=useState(false);
    const [errorInfo, setErrorInfo]=useState("");
    const [block1, setBlock1]=useState(true);

    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();

    const login = async(data)=>{
        try {
            const result = await Api({
                method:"post",
                url:`/auth/login`,
                data:data
            });
            sessionStorage.setItem('user_data', JSON.stringify(result.data));
            window.location.href='/Main_page';
        } catch (error) {
            // console.error(error);
            // const error_data=JSON.parse(error.message);
            setErrorInfo(error);
            setError(true);
        }
    }

    const authorization = async(e) => {
        e.preventDefault();
        setError(false);
        setLoading(true);
        setBlock1(false)
        const data={
            "username_or_email":document.getElementById("login_input").value,
            "password":document.getElementById("password_input").value
        }
        await login(data);
        setBlock1(true)
        setLoading(false);
    }

    const sendOtp = async() => {
        try {
            const result = await Api({
                method:"post",
                url:`/auth/send_otp_email`,
                data:{username_or_email:document.getElementById("login_input").value}
            })
            alert("Одноразовый пароль отправлен.")
        } catch (error) {
            setErrorInfo(`Проблема с получением одноразового пароля \n ${error}`);
            setError(true);
        }
    }
    
    const getOtp = async() => {
        if (document.getElementById("login_input").value==""){
            alert("Введите логин чтобы получить одноразовый пароль")
        }else{
            sendOtp();
        }
    }

    if(loading){
        return(<LoadingStuck/>)
    }

    if(block1){
        return(
            <>
            <div className="block_page_auth">
                <div className="auth_block">
                    <div className="auth_card_block">
                        <div>
                            <div className="auth_card_block_entery">
                                <div className="image_icon_block">
                                    <img 
                                        src={logo}
                                        className="image_icon_logo"
                                        alt="Logo" 
                                    />
                                </div>
                                <div className="welcome_text text_font">Добро пожаловать в AIDA</div>
                                <Form onSubmit={authorization}>
                                    <Form.Group className="mb-2">
                                        <Form.Control 
                                            type="text" 
                                            placeholder="Логин..."
                                            id="login_input"
                                            required
                                            />
                                    </Form.Group>
                                    <Form.Group className="mb-2">
                                        <Form.Control 
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Пароль..."
                                            id="password_input"
                                            required
                                            />
                                    </Form.Group>
                                    {/* <Form.Group className="mb-3">
                                        <Form.Control 
                                            type="text" 
                                            placeholder="Одноразовый пароль..." 
                                            maxLength={6}
                                            id="otp_input"
                                            />
                                    </Form.Group> */}
                                    <div className="mb-3">
                                        <Form.Check 
                                        checked={showPassword}
                                        onChange={(e) => setShowPassword(e.target.checked)}
                                        type="switch" 
                                        label="Скрыть/Показать пароль"
                                        />
                                    </div>
                                    {error && (<div className="mb-3 warning_text sepatate_text">{errorInfo}</div>)}
                                    {/* <div className="mb-3">
                                        <Button className="custom-btn free-btn btn-round" onClick={()=>getOtp()}>Получить одноразовый код</Button>
                                    </div> */}
                                    <div className="mb-2">
                                        <Button 
                                            variant="primary" 
                                            className="free-btn" 
                                            type="submit">Войти в аккаунт</Button>
                                    </div>
                                    <div className="mb-2">
                                        <RestorePasswordModal/>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                    <div className="doc_link_block">
                        <p>Нажимая кнопку "войти в аккаунт", я принимаю 
                            <a href={personal_data_doc} className="link_doc_text"> согласие на обработку персональных данных.</a>
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
    }

}
export default LoginForm;
